import { makeStyles } from '@mui/styles';

const styles = (theme) => ({

  logoSpace: ( { commonUIStyles }) => {
    return  {
        position: 'absolute',
        width: '100%',
        display: 'flex',
        maxHeight: '120px',
        overflow: 'visible',
        justifyContent: 'center',
        alignItems:'center',
        ...commonUIStyles.logoSpace(),
    };
  },

  logo: ({ widget, commonUIStyles }) => {
    // const hasCustomCSS = widgetTheme.hasCustomCSS;
    const style = {
      ...commonUIStyles.logo(),
      overflowClipMargin: 'content-box',
      overflow: 'clip',
    };
    if (widget.logo_shadow || widget.logoShadow) {
      style.filter = 'drop-shadow(0px 4px 4px #00000026)';
    }
    return style;
  },

});

export default styles;
export const useStyles = makeStyles(styles);
